module.exports = (Promise.resolve(__parcel__require__("./" + "module.54a8d6d6.e7f94c6f.js"))).then(() => parcelRequire('jMH4N'));